import {
  StateData,
  DistrictData,
  DISCOMData,
  CircleData,
  Alarm,
  AlarmSeverity,
  ServiceTicket,
  TicketStatus,
  RMSDevice,
  PlantStatus,
  ConsumerPlant,
  VendorPlant,
  GenerationDataPoint,
  MonthlyDataPoint,
  HourlyDataPoint,
  VoltageDataPoint,
  FaultDistribution,
  BillingCycle,
  FeederData,
  VarianceAlert,
  CommandLog,
} from '../types';

// ─── National KPIs ───────────────────────────────────────────────────────────
export const nationalKPIs = {
  totalPlants: 28450,
  newPlantsMonth: 342,
  installedCapacityGWp: 9.1,
  statesCount: 28,
  todayGenerationGWh: 36,
  generationChangePercent: 6.2,
  activePlants: 24318,
  activePercent: 85.4,
  offlineFault: 4132,
  offlinePercent: 14.6,
  avgPR: 74.3,
  avgCUF: 18.6,
  co2OffsetMT: 1.24,
  monthlyGWh: 892,
  lifetimeTWh: 4.7,
  peakGW: 7.8,
  avgSpecificYield: 3.95,
  statesActive: 28,
  discoomsOnboarded: 64,
  districtsCovered: 312,
  feedersMonitored: 4820,
  activeAlarms: 1247,
  criticalAlarms: 183,
  warningAlarms: 641,
  infoAlarms: 423,
  resolvedToday: 89,
  mttrHours: 4.2,
  dataTransmissionPercent: 97.3,
  mnreComplianceScore: 88,
  outdatedFirmware: 342,
  certsExpiring: 67,
  platformUptime: 99.94,
};

// ─── States ───────────────────────────────────────────────────────────────────
export const statesData: StateData[] = [
  {
    id: 'GJ',
    name: 'Gujarat',
    plants: 6240,
    capacityGWp: 2.1,
    generationGWh: 9.84,
    prPercent: 78.2,
    cufPercent: 21.4,
    activePercent: 91.0,
    alarms: 142,
    momTrend: 3.2,
    status: 'online',
  },
  {
    id: 'TN',
    name: 'Tamil Nadu',
    plants: 5120,
    capacityGWp: 1.8,
    generationGWh: 8.12,
    prPercent: 76.5,
    cufPercent: 19.8,
    activePercent: 89.0,
    alarms: 98,
    momTrend: 1.8,
    status: 'online',
  },
  {
    id: 'RJ',
    name: 'Rajasthan',
    plants: 4380,
    capacityGWp: 1.5,
    generationGWh: 6.54,
    prPercent: 75.1,
    cufPercent: 20.2,
    activePercent: 87.0,
    alarms: 211,
    momTrend: -1.2,
    status: 'warning',
  },
  {
    id: 'MH',
    name: 'Maharashtra',
    plants: 3960,
    capacityGWp: 1.3,
    generationGWh: 5.43,
    prPercent: 72.8,
    cufPercent: 18.1,
    activePercent: 84.0,
    alarms: 187,
    momTrend: 0.5,
    status: 'online',
  },
  {
    id: 'KA',
    name: 'Karnataka',
    plants: 3240,
    capacityGWp: 1.1,
    generationGWh: 4.21,
    prPercent: 74.3,
    cufPercent: 17.6,
    activePercent: 86.0,
    alarms: 134,
    momTrend: 2.1,
    status: 'online',
  },
  {
    id: 'MP',
    name: 'Madhya Pradesh',
    plants: 2840,
    capacityGWp: 0.9,
    generationGWh: 3.18,
    prPercent: 67.4,
    cufPercent: 16.3,
    activePercent: 78.0,
    alarms: 298,
    momTrend: -3.4,
    status: 'warning',
  },
  {
    id: 'KL',
    name: 'Kerala',
    plants: 1820,
    capacityGWp: 0.6,
    generationGWh: 2.83,
    prPercent: 70.1,
    cufPercent: 15.8,
    activePercent: 82.0,
    alarms: 76,
    momTrend: 0.9,
    status: 'online',
  },
  {
    id: 'UP',
    name: 'Uttar Pradesh',
    plants: 850,
    capacityGWp: 0.3,
    generationGWh: 1.11,
    prPercent: 65.2,
    cufPercent: 14.1,
    activePercent: 74.0,
    alarms: 101,
    momTrend: -2.1,
    status: 'warning',
  },
];

// ─── DISCOMs for Gujarat ──────────────────────────────────────────────────────
export const gujaratDISCOMs: DISCOMData[] = [
  {
    id: 'PGVCL',
    name: 'PGVCL',
    state: 'Gujarat',
    plants: 2840,
    capacityGWp: 0.96,
    generationGWh: 4.48,
    prPercent: 79.1,
    activePercent: 92.0,
    alarms: 58,
  },
  {
    id: 'MGVCL',
    name: 'MGVCL',
    state: 'Gujarat',
    plants: 1680,
    capacityGWp: 0.56,
    generationGWh: 2.64,
    prPercent: 77.8,
    activePercent: 90.0,
    alarms: 41,
  },
  {
    id: 'DGVCL',
    name: 'DGVCL',
    state: 'Gujarat',
    plants: 980,
    capacityGWp: 0.33,
    generationGWh: 1.54,
    prPercent: 76.2,
    activePercent: 89.5,
    alarms: 28,
  },
  {
    id: 'UGVCL',
    name: 'UGVCL',
    state: 'Gujarat',
    plants: 740,
    capacityGWp: 0.25,
    generationGWh: 1.18,
    prPercent: 78.5,
    activePercent: 91.2,
    alarms: 15,
  },
];

// ─── Gujarat Districts ────────────────────────────────────────────────────────
export const gujaratDistricts: DistrictData[] = [
  /* ── Top 5 (existing) ─────────────────────────────────────────────── */
  { id: 'AMD', name: 'Ahmedabad',    plants: 1420, generationGWh: 2.81, prPercent: 78.4, status: 'online'  },
  { id: 'SUR', name: 'Surat',        plants:  980, generationGWh: 1.94, prPercent: 76.9, status: 'online'  },
  { id: 'VDR', name: 'Vadodara',     plants:  760, generationGWh: 1.51, prPercent: 77.2, status: 'online'  },
  { id: 'RJK', name: 'Rajkot',       plants:  620, generationGWh: 1.22, prPercent: 79.8, status: 'online'  },
  { id: 'JND', name: 'Junagadh',     plants:  480, generationGWh: 0.91, prPercent: 74.1, status: 'warning' },
  /* ── Remaining Gujarat districts ──────────────────────────────────── */
  { id: 'BHR', name: 'Bharuch',      plants:  420, generationGWh: 0.84, prPercent: 77.9, status: 'online'  },
  { id: 'KTC', name: 'Kachchh',      plants:  380, generationGWh: 0.76, prPercent: 76.3, status: 'online'  },
  { id: 'BHV', name: 'Bhavnagar',    plants:  355, generationGWh: 0.71, prPercent: 76.8, status: 'online'  },
  { id: 'GND', name: 'Gandhinagar',  plants:  340, generationGWh: 0.68, prPercent: 77.5, status: 'online'  },
  { id: 'JMN', name: 'Jamnagar',     plants:  295, generationGWh: 0.59, prPercent: 75.6, status: 'online'  },
  { id: 'JMG', name: 'Jamnagar',     plants:  280, generationGWh: 0.56, prPercent: 74.9, status: 'online'  },
  { id: 'NVS', name: 'Navsari',      plants:  265, generationGWh: 0.53, prPercent: 75.1, status: 'online'  },
  { id: 'BNK', name: 'Banas Kantha', plants:  260, generationGWh: 0.52, prPercent: 72.4, status: 'warning' },
  { id: 'AMR', name: 'Amreli',       plants:  245, generationGWh: 0.49, prPercent: 73.5, status: 'online'  },
  { id: 'SRN', name: 'Surendranagar',plants:  230, generationGWh: 0.46, prPercent: 72.9, status: 'online'  },
  { id: 'VLS', name: 'Valsad',       plants:  220, generationGWh: 0.44, prPercent: 74.5, status: 'online'  },
  { id: 'AND', name: 'Anand',        plants:  390, generationGWh: 0.78, prPercent: 76.1, status: 'online'  },
  { id: 'PTN', name: 'Patan',        plants:  210, generationGWh: 0.42, prPercent: 73.9, status: 'online'  },
  { id: 'PRB', name: 'Porbandar',    plants:  180, generationGWh: 0.36, prPercent: 74.2, status: 'online'  },
  { id: 'PMH', name: 'Panch Mahals', plants:  175, generationGWh: 0.35, prPercent: 71.2, status: 'online'  },
  { id: 'SBK', name: 'Sabar Kantha', plants:  195, generationGWh: 0.39, prPercent: 71.8, status: 'online'  },
  { id: 'KHD', name: 'Kheda',        plants:  310, generationGWh: 0.62, prPercent: 75.3, status: 'online'  },
  { id: 'MHN', name: 'Mahesana',     plants:  285, generationGWh: 0.57, prPercent: 74.8, status: 'online'  },
  { id: 'NRM', name: 'Narmada',      plants:  135, generationGWh: 0.27, prPercent: 70.1, status: 'online'  },
  { id: 'DHD', name: 'Dahod',        plants:  145, generationGWh: 0.29, prPercent: 69.8, status: 'warning' },
  { id: 'TAP', name: 'Tapi',         plants:  110, generationGWh: 0.22, prPercent: 68.9, status: 'online'  },
  { id: 'DNG', name: 'The Dangs',    plants:   45, generationGWh: 0.09, prPercent: 67.2, status: 'warning' },
];

// ─── PGVCL Circles ────────────────────────────────────────────────────────────
export const pgvclCircles: CircleData[] = [
  { id: 'AMD-C', name: 'Ahmedabad Circle', plants: 920, generationMWh: 1824, prPercent: 79.4, activePercent: 93.2, alarms: 18, mttrHours: 3.8 },
  { id: 'GND-C', name: 'Gandhinagar Circle', plants: 640, generationMWh: 1267, prPercent: 78.9, activePercent: 91.8, alarms: 12, mttrHours: 4.1 },
  { id: 'ANK-C', name: 'Ankleshwar Circle', plants: 520, generationMWh: 1031, prPercent: 80.1, activePercent: 94.0, alarms: 9, mttrHours: 3.2 },
  { id: 'KDA-C', name: 'Kheda Circle', plants: 340, generationMWh: 673, prPercent: 77.6, activePercent: 90.1, alarms: 14, mttrHours: 5.2 },
  { id: 'MEH-C', name: 'Mehsana Circle', plants: 420, generationMWh: 830, prPercent: 78.2, activePercent: 92.5, alarms: 5, mttrHours: 3.6 },
];

// ─── National Generation (15 days) ───────────────────────────────────────────
export const nationalDailyGeneration: GenerationDataPoint[] = [
  { label: '13 Apr', value: 33.2 },
  { label: '14 Apr', value: 34.8 },
  { label: '15 Apr', value: 31.5 },
  { label: '16 Apr', value: 35.1 },
  { label: '17 Apr', value: 36.4 },
  { label: '18 Apr', value: 34.9 },
  { label: '19 Apr', value: 32.8 },
  { label: '20 Apr', value: 37.2 },
  { label: '21 Apr', value: 35.6 },
  { label: '22 Apr', value: 38.1 },
  { label: '23 Apr', value: 36.9 },
  { label: '24 Apr', value: 35.4 },
  { label: '25 Apr', value: 37.8 },
  { label: '26 Apr', value: 33.9 },
  { label: '27 Apr', value: 36.0, highlighted: true },
];

export const nationalMonthlyGeneration: GenerationDataPoint[] = [
  { label: 'Nov', value: 718 },
  { label: 'Dec', value: 652 },
  { label: 'Jan', value: 741 },
  { label: 'Feb', value: 798 },
  { label: 'Mar', value: 864 },
  { label: 'Apr', value: 892, highlighted: true },
];

export const nationalHourlyGeneration: GenerationDataPoint[] = [
  { label: '6AM', value: 2.1 },
  { label: '7AM', value: 8.4 },
  { label: '8AM', value: 18.6 },
  { label: '9AM', value: 28.3 },
  { label: '10AM', value: 34.7 },
  { label: '11AM', value: 38.9 },
  { label: '12PM', value: 40.2, highlighted: true },
  { label: '1PM', value: 39.1 },
  { label: '2PM', value: 36.8 },
  { label: '3PM', value: 31.4 },
  { label: '4PM', value: 22.6 },
  { label: '5PM', value: 12.1 },
  { label: '6PM', value: 3.4 },
];

// ─── State (Gujarat) Generation ───────────────────────────────────────────────
export const gujaratDailyGeneration: GenerationDataPoint[] = [
  { label: '13 Apr', value: 8.92 },
  { label: '14 Apr', value: 9.34 },
  { label: '15 Apr', value: 8.41 },
  { label: '16 Apr', value: 9.18 },
  { label: '17 Apr', value: 9.67 },
  { label: '18 Apr', value: 9.22 },
  { label: '19 Apr', value: 8.78 },
  { label: '20 Apr', value: 9.91 },
  { label: '21 Apr', value: 9.45 },
  { label: '22 Apr', value: 10.12 },
  { label: '23 Apr', value: 9.83 },
  { label: '24 Apr', value: 9.38 },
  { label: '25 Apr', value: 10.04 },
  { label: '26 Apr', value: 8.96 },
  { label: '27 Apr', value: 9.84, highlighted: true },
];

export const gujaratPRTrend = [
  { month: 'Nov', value: 74.1 },
  { month: 'Dec', value: 73.8 },
  { month: 'Jan', value: 75.2 },
  { month: 'Feb', value: 76.4 },
  { month: 'Mar', value: 77.1 },
  { month: 'Apr', value: 78.2 },
];

export const gujaratMonthlyGeneration: GenerationDataPoint[] = [
  { label: 'Nov', value: 218.4 },
  { label: 'Dec', value: 204.6 },
  { label: 'Jan', value: 226.8 },
  { label: 'Feb', value: 236.1 },
  { label: 'Mar', value: 248.9 },
  { label: 'Apr', value: 241.0, highlighted: true },
];

export const gujaratHourlyGeneration: GenerationDataPoint[] = [
  { label: '6AM',  value: 128 },
  { label: '7AM',  value: 312 },
  { label: '8AM',  value: 548 },
  { label: '9AM',  value: 742 },
  { label: '10AM', value: 882 },
  { label: '11AM', value: 1024 },
  { label: '12PM', value: 1124, highlighted: true },
  { label: '1PM',  value: 1086 },
  { label: '2PM',  value: 984 },
  { label: '3PM',  value: 824 },
  { label: '4PM',  value: 612 },
  { label: '5PM',  value: 348 },
  { label: '6PM',  value: 104 },
];

// ─── State generation by DISCOM ───────────────────────────────────────────────
export const discomGenerationBars = [
  { label: 'PGVCL', value: 4.48 },
  { label: 'MGVCL', value: 2.64 },
  { label: 'DGVCL', value: 1.54 },
  { label: 'UGVCL', value: 1.18 },
];

// ─── Top 5 Performing Plants ──────────────────────────────────────────────────
export const top5Plants = [
  { id: 'GJ-1024', state: 'Gujarat', kwhToday: 48.2, pr: 88.4 },
  { id: 'TN-0312', state: 'Tamil Nadu', kwhToday: 46.9, pr: 87.1 },
  { id: 'RJ-2201', state: 'Rajasthan', kwhToday: 45.8, pr: 86.3 },
  { id: 'GJ-0891', state: 'Gujarat', kwhToday: 44.6, pr: 85.9 },
  { id: 'KA-0554', state: 'Karnataka', kwhToday: 43.1, pr: 85.2 },
];

// ─── Alarms ───────────────────────────────────────────────────────────────────
export const nationalAlarms: Alarm[] = [
  {
    id: 'ALM-8821',
    severity: AlarmSeverity.CRITICAL,
    description: 'Grid voltage out of range — inverter tripped',
    parameter: 'ACVOLT',
    plantId: 'RJ-2201',
    state: 'Rajasthan',
    timestamp: '2026-04-28T10:42:00',
    duration: '1h 18m',
    status: 'ACTIVE',
    faultType: 'Voltage FT1',
  },
  {
    id: 'ALM-8820',
    severity: AlarmSeverity.WARNING,
    description: 'MPPT 2 power consistently lower than MPPT 1',
    parameter: 'DCKW2',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-04-26T08:15:00',
    duration: '2 days',
    status: 'ACTIVE',
    faultType: 'Other',
  },
  {
    id: 'ALM-8819',
    severity: AlarmSeverity.INFO,
    description: 'Communication loss — datalogger offline',
    parameter: 'COMMS',
    plantId: 'MP-1102',
    state: 'Madhya Pradesh',
    timestamp: '2026-04-28T09:30:00',
    duration: '2h 30m',
    status: 'ACTIVE',
    faultType: 'Comms',
  },
  {
    id: 'ALM-8818',
    severity: AlarmSeverity.CRITICAL,
    description: 'Inverter over-temperature shutdown',
    parameter: 'INVTEMP',
    plantId: 'MH-0934',
    state: 'Maharashtra',
    timestamp: '2026-04-28T11:05:00',
    duration: '55m',
    status: 'ACTIVE',
    faultType: 'Temperature FT4',
  },
  {
    id: 'ALM-8817',
    severity: AlarmSeverity.WARNING,
    description: 'Grid frequency deviation detected',
    parameter: 'ACFREQ',
    plantId: 'TN-0312',
    state: 'Tamil Nadu',
    timestamp: '2026-04-28T07:48:00',
    duration: '4h 12m',
    status: 'ACTIVE',
    faultType: 'Frequency FT2',
  },
  {
    id: 'ALM-8812',
    severity: AlarmSeverity.INFO,
    description: 'Communication restored after 3h offline',
    parameter: 'COMMS',
    plantId: 'KA-0554',
    state: 'Karnataka',
    timestamp: '2026-04-27T14:22:00',
    duration: '3h 4m',
    status: 'RESOLVED',
    faultType: 'Comms',
  },
];

export const consumerAlarms: Alarm[] = [
  {
    id: 'ALM-8820',
    severity: AlarmSeverity.WARNING,
    description: 'MPPT 2 power consistently lower than MPPT 1 — possible soiling or shading',
    parameter: 'DCKW2',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-04-26T08:15:00',
    duration: '2 days',
    status: 'ACTIVE',
    faultType: 'MPPT',
  },
  {
    id: 'ALM-8754',
    severity: AlarmSeverity.INFO,
    description: 'Communication loss — datalogger offline for 45 minutes',
    parameter: 'COMMS',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-04-25T14:10:00',
    duration: '45m',
    status: 'RESOLVED',
    faultType: 'Comms',
  },
  {
    id: 'ALM-8698',
    severity: AlarmSeverity.WARNING,
    description: 'Grid voltage high — 248V sustained for 12 minutes',
    parameter: 'ACVOLT',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-04-18T11:32:00',
    duration: '12m',
    status: 'RESOLVED',
    faultType: 'Voltage FT1',
  },
  {
    id: 'ALM-8621',
    severity: AlarmSeverity.INFO,
    description: 'Inverter restart after firmware update',
    parameter: 'INV',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-03-15T09:00:00',
    duration: '4m',
    status: 'RESOLVED',
    faultType: 'Comms',
  },
  {
    id: 'ALM-8512',
    severity: AlarmSeverity.WARNING,
    description: 'DC string 1 undervoltage — possible shading event',
    parameter: 'DCVOLT1',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2026-02-22T13:45:00',
    duration: '1h 22m',
    status: 'RESOLVED',
    faultType: 'Voltage FT1',
  },
  {
    id: 'ALM-8401',
    severity: AlarmSeverity.INFO,
    description: 'Communication loss during power outage',
    parameter: 'COMMS',
    plantId: 'GJ-0482',
    state: 'Gujarat',
    timestamp: '2025-09-10T16:20:00',
    duration: '2h 15m',
    status: 'RESOLVED',
    faultType: 'Comms',
  },
];

// ─── Fault Distribution ────────────────────────────────────────────────────────
export const faultDistribution: FaultDistribution[] = [
  { name: 'Comms', value: 43, color: '#2472C8' },
  { name: 'Voltage FT1', value: 22, color: '#B52020' },
  { name: 'Temperature FT4', value: 14, color: '#C25A0A' },
  { name: 'Frequency FT2', value: 11, color: '#5B3FA6' },
  { name: 'Other', value: 10, color: '#0D6B5A' },
];

// ─── Compliance ───────────────────────────────────────────────────────────────
export const stateCompliance = [
  { state: 'Gujarat', percent: 96.4, status: 'green' },
  { state: 'Tamil Nadu', percent: 94.1, status: 'green' },
  { state: 'Rajasthan', percent: 89.3, status: 'green' },
  { state: 'Maharashtra', percent: 87.6, status: 'green' },
  { state: 'Karnataka', percent: 83.2, status: 'amber' },
  { state: 'Madhya Pradesh', percent: 71.4, status: 'amber' },
  { state: 'Kerala', percent: 67.8, status: 'red' },
];

// ─── Consumer Plant GJ-0482 ───────────────────────────────────────────────────
export const consumerPlant: ConsumerPlant = {
  id: 'GJ-0482',
  consumerName: 'Amitbhai Patel',
  address: 'Plot 14, Satellite Road, Ahmedabad, Gujarat 380015',
  capacityKWp: 6,
  inverterBrand: 'Sofar',
  discom: 'PGVCL',
  state: 'Gujarat',
  district: 'Ahmedabad',
  commissionDate: '2025-01-10',
  status: PlantStatus.ONLINE,
  livePowerKW: 4.2,
  todayKWh: 14.55,
  todaySavings: 109,
  prPercent: 76.4,
  lifetimeKWh: 3842,
  lifetimeSavings: 28815,
  co2OffsetMT: 2.73,
  healthScore: 82,
  electrical: {
    dcVoltage1: 330,
    dcCurrent1: 12.4,
    dcPower1: 4.09,
    dcVoltage2: 318,
    dcCurrent2: 11.8,
    dcPower2: 3.75,
    acVoltage: 241,
    acCurrent: 17.4,
    frequency: 49.98,
    powerFactor: 0.97,
    reactivePower: 0.62,
    apparentPower: 4.33,
    inverterTemp: 58,
    inverterStatus: 'ON',
    onTimeHours: 8.4,
    activePower: 4.2,
  },
  prNeighbours: [
    { label: 'My plant', value: 76.4, isMe: true },
    { label: 'Pincode avg 380015', value: 72.1, isMe: false },
    { label: 'District avg Ahmedabad', value: 70.3, isMe: false },
    { label: 'State avg Gujarat', value: 74.2, isMe: false },
  ],
};

// ─── Consumer power curve ─────────────────────────────────────────────────────
export const consumerPowerCurve: HourlyDataPoint[] = [
  { time: '6AM', power: 0.1 },
  { time: '6:30', power: 0.4 },
  { time: '7AM', power: 0.9 },
  { time: '7:30', power: 1.4 },
  { time: '8AM', power: 1.9 },
  { time: '8:30', power: 2.5 },
  { time: '9AM', power: 3.1 },
  { time: '9:30', power: 3.6 },
  { time: '10AM', power: 4.0 },
  { time: '10:30', power: 4.4 },
  { time: '11AM', power: 4.7 },
  { time: '11:30', power: 4.9 },
  { time: '12PM', power: 5.1 },
  { time: '12:30', power: 5.0 },
  { time: '1PM', power: 4.8 },
  { time: '1:30', power: 4.5 },
  { time: '2PM', power: 4.2 },
  { time: '2:30', power: 3.8 },
  { time: '3PM', power: 3.2 },
  { time: '3:30', power: 2.6 },
  { time: '4PM', power: 2.0 },
  { time: '4:30', power: 1.3 },
  { time: '5PM', power: 0.7 },
  { time: '5:30', power: 0.3 },
  { time: '6PM', power: 0.0 },
];

// ─── AC Voltage trend ─────────────────────────────────────────────────────────
export const acVoltageTrend: VoltageDataPoint[] = [
  { time: '6AM', voltage: 239 },
  { time: '7AM', voltage: 240 },
  { time: '8AM', voltage: 241 },
  { time: '9AM', voltage: 242 },
  { time: '10AM', voltage: 243 },
  { time: '11AM', voltage: 244 },
  { time: '12PM', voltage: 243 },
  { time: '1PM', voltage: 242 },
  { time: '2PM', voltage: 241 },
  { time: '3PM', voltage: 240 },
  { time: '4PM', voltage: 241 },
  { time: '5PM', voltage: 240 },
  { time: '6PM', voltage: 239 },
];

// ─── Monthly generation & export ──────────────────────────────────────────────
export const consumerMonthlyData: MonthlyDataPoint[] = [
  { month: 'Nov', generated: 412, exported: 198 },
  { month: 'Dec', generated: 374, exported: 162 },
  { month: 'Jan', generated: 421, exported: 207 },
  { month: 'Feb', generated: 498, exported: 241 },
  { month: 'Mar', generated: 563, exported: 278 },
  { month: 'Apr', generated: 574, exported: 312 },
];

// ─── Billing cycles ───────────────────────────────────────────────────────────
export const billingCycles: BillingCycle[] = [
  { month: 'Apr 2026', exportKWh: 312, importKWh: 148, estimatedCredit: 1716 },
  { month: 'Mar 2026', exportKWh: 278, importKWh: 162, estimatedCredit: 1529 },
  { month: 'Feb 2026', exportKWh: 241, importKWh: 179, estimatedCredit: 1326 },
];

// ─── Service Tickets ──────────────────────────────────────────────────────────
export const consumerTickets: ServiceTicket[] = [
  {
    id: 'TKT-2024-0481',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Inverter / MPPT fault',
    description: 'MPPT 2 output is consistently 8% lower than MPPT 1. Possible soiling or partial shading on string 2. Request site inspection.',
    raisedDate: '2026-04-26',
    assignedTo: 'Ravi Kumar',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.OPEN,
    priority: 'NORMAL',
  },
  {
    id: 'TKT-2024-0398',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Communication / Datalogger issue',
    description: 'Datalogger went offline intermittently for 45 minutes.',
    raisedDate: '2026-04-25',
    assignedTo: 'Priya Shah',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    resolutionTime: '0.5 days',
    priority: 'LOW',
  },
  {
    id: 'TKT-2024-0302',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Grid voltage issue',
    description: 'Inverter reported high grid voltage causing brief shutdown.',
    raisedDate: '2026-04-18',
    assignedTo: 'Ravi Kumar',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    resolutionTime: '1.2 days',
    priority: 'NORMAL',
  },
  {
    id: 'TKT-2024-0187',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Panel cleaning request',
    description: 'Requesting scheduled cleaning for optimal performance.',
    raisedDate: '2026-02-10',
    assignedTo: 'Suresh Patel',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    resolutionTime: '3.0 days',
    priority: 'LOW',
  },
];

// ─── RMS Devices ──────────────────────────────────────────────────────────────
export const rmsDevices: RMSDevice[] = [
  {
    imei: '354678901234567',
    plantId: 'GJ-0482',
    status: PlantStatus.ONLINE,
    firmwareVersion: '2.4.1',
    certExpiry: '2026-05-15',
    lastSeen: '2026-04-28T12:00:00',
    daysToExpiry: 17,
  },
  {
    imei: '354678901234568',
    plantId: 'GJ-1024',
    status: PlantStatus.ONLINE,
    firmwareVersion: '2.3.8',
    certExpiry: '2026-06-30',
    lastSeen: '2026-04-28T11:55:00',
    daysToExpiry: 63,
  },
  {
    imei: '354678901234569',
    plantId: 'RJ-2201',
    status: PlantStatus.OFFLINE,
    firmwareVersion: '2.2.1',
    certExpiry: '2026-04-10',
    lastSeen: '2026-04-27T08:30:00',
    daysToExpiry: -18,
  },
  {
    imei: '354678901234570',
    plantId: 'TN-0312',
    status: PlantStatus.ONLINE,
    firmwareVersion: '2.4.1',
    certExpiry: '2026-12-01',
    lastSeen: '2026-04-28T11:58:00',
    daysToExpiry: 217,
  },
  {
    imei: '354678901234571',
    plantId: 'MP-1102',
    status: PlantStatus.WARNING,
    firmwareVersion: '2.1.4',
    certExpiry: '2026-05-08',
    lastSeen: '2026-04-28T09:45:00',
    daysToExpiry: 10,
  },
];

// ─── Vendor Plants (summary) ──────────────────────────────────────────────────
const vendorStates = ['Gujarat', 'Tamil Nadu', 'Rajasthan', 'Maharashtra', 'Karnataka'];
const vendorInverters = ['Sofar', 'Growatt', 'Solis', 'Delta', 'Sungrow'];
const commissionStatuses: VendorPlant['commissionStatus'][] = ['COMMISSIONED', 'COMMISSIONED', 'COMMISSIONED', 'PENDING', 'UNDER_TEST', 'INACTIVE'];

function generateVendorPlants(): VendorPlant[] {
  const plants: VendorPlant[] = [];
  for (let i = 1; i <= 342; i++) {
    const prVal = 60 + Math.round(Math.random() * 30);
    const statusOptions: PlantStatus[] = [PlantStatus.ONLINE, PlantStatus.ONLINE, PlantStatus.ONLINE, PlantStatus.OFFLINE, PlantStatus.WARNING];
    plants.push({
      id: `ZB-${String(i).padStart(4, '0')}`,
      consumerName: `Consumer ${i}`,
      state: vendorStates[i % vendorStates.length],
      district: 'District',
      inverterBrand: vendorInverters[i % vendorInverters.length],
      status: i === 1 ? PlantStatus.ONLINE : statusOptions[i % statusOptions.length],
      todayKWh: parseFloat((8 + Math.random() * 20).toFixed(1)),
      prPercent: prVal,
      lastSeen: '2026-04-28T11:00:00',
      activeAlarms: prVal < 68 ? 1 : 0,
      ticketStatus: i % 10 === 0 ? TicketStatus.OPEN : null,
      commissionStatus: commissionStatuses[i % commissionStatuses.length],
      capacityKWp: [3, 5, 6, 8, 10][i % 5],
    });
  }
  return plants;
}

export const vendorPlants: VendorPlant[] = generateVendorPlants();

export const vendorKPIs = {
  totalPlants: 342,
  totalCapacityMWp: 1.8,
  todayMWh: 6.2,
  activePlants: 324,
  offlinePlants: 18,
  lowPRPlants: 31,
  commissioned: 298,
  pending: 28,
  underTest: 12,
  inactive: 4,
  avgCufPct: 18.9,
  co2OffsetMT: 0.22,
  avgPrPct: 78.4,
};

export const vendorTickets: ServiceTicket[] = [
  {
    id: 'TKT-2024-0481',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Inverter / MPPT fault',
    description: 'MPPT 2 output consistently lower',
    raisedDate: '2026-04-26',
    assignedTo: 'Ravi Kumar',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.OPEN,
    priority: 'NORMAL',
  },
  {
    id: 'TKT-2024-0467',
    plantId: 'ZB-0023',
    consumerName: 'Bharat Shah',
    issueType: 'Communication failure',
    description: 'Datalogger offline since morning',
    raisedDate: '2026-04-27',
    assignedTo: 'Priya Shah',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.IN_PROGRESS,
    priority: 'HIGH',
    resolutionTime: undefined,
  },
  {
    id: 'TKT-2024-0441',
    plantId: 'ZB-0101',
    consumerName: 'Lalitha Devi',
    issueType: 'Inverter shutdown',
    description: 'Grid fault caused inverter trip',
    raisedDate: '2026-04-20',
    assignedTo: 'Suresh Patel',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    priority: 'HIGH',
    resolutionTime: '1.5 days',
  },
  {
    id: 'TKT-2024-0398',
    plantId: 'GJ-0482',
    consumerName: 'Amitbhai Patel',
    issueType: 'Communication / Datalogger issue',
    description: 'Datalogger offline intermittently',
    raisedDate: '2026-04-25',
    assignedTo: 'Priya Shah',
    assignedVendor: 'Zebron Solar',
    status: TicketStatus.RESOLVED,
    priority: 'LOW',
    resolutionTime: '0.5 days',
  },
];

// ─── DISCOM (PGVCL) KPIs ──────────────────────────────────────────────────────
export const pgvclKPIs = {
  feederGenerationMW: 148.4,
  avgFeederVoltage: 241.3,
  solarPenetrationPercent: 18.6,
  activeAlarms: 58,
  sldcFeedStatus: 'LIVE',
  importMWh: 312.4,
  exportMWh: 289.6,
  risingDemandMW: 42.1,
  gridFailureEvents: 2,
  tamperCount: 7,
};

// ─── Feeder Data ──────────────────────────────────────────────────────────────
export const feeders: FeederData[] = [
  { id: 'FDR-AMD-01', name: 'Satellite Road Feeder', circle: 'Ahmedabad', generationMW: 18.4, plants: 124, penetrationPercent: 22.1, avgVoltage: 242, alarms: 3 },
  { id: 'FDR-AMD-02', name: 'Bopal Feeder', circle: 'Ahmedabad', generationMW: 14.2, plants: 98, penetrationPercent: 18.4, avgVoltage: 240, alarms: 1 },
  { id: 'FDR-GND-01', name: 'Gandhinagar Sector 8', circle: 'Gandhinagar', generationMW: 12.6, plants: 87, penetrationPercent: 19.8, avgVoltage: 241, alarms: 2 },
  { id: 'FDR-ANK-01', name: 'GIDC Feeder', circle: 'Ankleshwar', generationMW: 9.8, plants: 64, penetrationPercent: 15.2, avgVoltage: 239, alarms: 0 },
  { id: 'FDR-MEH-01', name: 'Mehsana North Feeder', circle: 'Mehsana', generationMW: 8.1, plants: 52, penetrationPercent: 14.6, avgVoltage: 243, alarms: 1 },
];

// ─── Net metering — import/export bars ───────────────────────────────────────
export const pgvclImportExportData = [
  { month: 'Nov', import: 241.2, export: 218.4 },
  { month: 'Dec', import: 228.6, export: 201.3 },
  { month: 'Jan', import: 258.1, export: 234.7 },
  { month: 'Feb', import: 281.4, export: 261.8 },
  { month: 'Mar', import: 304.2, export: 280.9 },
  { month: 'Apr', import: 312.4, export: 289.6 },
];

// ─── Variance Alerts ──────────────────────────────────────────────────────────
export const varianceAlerts: VarianceAlert[] = [
  { plantId: 'GJ-1842', consumerName: 'Vinod Mehta', inverterKWh: 28.4, meterKWh: 26.2, variancePercent: 7.7, status: 'REVIEW' },
  { plantId: 'GJ-0934', consumerName: 'Meena Trivedi', inverterKWh: 31.2, meterKWh: 28.8, variancePercent: 7.7, status: 'REVIEW' },
  { plantId: 'GJ-2201', consumerName: 'Ashok Bhatt', inverterKWh: 22.8, meterKWh: 20.9, variancePercent: 8.3, status: 'REVIEW' },
  { plantId: 'GJ-1101', consumerName: 'Sonal Desai', inverterKWh: 18.4, meterKWh: 17.8, variancePercent: 3.3, status: 'CLEAR' },
];

// ─── Command Logs ─────────────────────────────────────────────────────────────
export const commandLogs: CommandLog[] = [
  { timestamp: '2026-04-28T10:30:00', command: 'Voltage Setpoint → 242V', issuedBy: 'Er. Mehta (PGVCL)', plantId: 'FDR-AMD-01', result: 'SUCCESS' },
  { timestamp: '2026-04-27T14:15:00', command: 'Reactive Power → 0.8 kVAr', issuedBy: 'Er. Mehta (PGVCL)', plantId: 'FDR-GND-01', result: 'SUCCESS' },
  { timestamp: '2026-04-26T09:00:00', command: 'Voltage Setpoint → 240V', issuedBy: 'Er. Joshi (PGVCL)', plantId: 'FDR-AMD-02', result: 'FAILED' },
  { timestamp: '2026-04-25T16:45:00', command: 'Reactive Power → 0.6 kVAr', issuedBy: 'Er. Joshi (PGVCL)', plantId: 'FDR-ANK-01', result: 'SUCCESS' },
];

// ─── State KPIs ───────────────────────────────────────────────────────────────
export const gujaratStateKPIs = {
  plants: 6240,
  capacityGWp: 2.1,
  generationGWh: 9.84,
  activePercent: 91,
  offlineFaultCount: 562,
  discoms: 4,
  districts: 33,
  alarms: 142,
  avgPR: 78.2,
  avgCufPct: 19.2,
  co2OffsetMT: 0.84,
};

// ─── State-scoped fault distribution (separate ref for StateAlarms donut) ────
export const stateFaultDistribution: FaultDistribution[] = [
  { name: 'Comms Loss', value: 38, color: '#2472C8' },
  { name: 'Voltage Fault', value: 26, color: '#B52020' },
  { name: 'Temperature', value: 16, color: '#C25A0A' },
  { name: 'Frequency', value: 12, color: '#5B3FA6' },
  { name: 'Other', value: 8, color: '#0D6B5A' },
];

// ─── Consumer — last 15 min energy ───────────────────────────────────────────
export const consumerLast15MinKwh = 1.05;

// ─── DISCOM (PGVCL) Overview KPIs ────────────────────────────────────────────
export const pgvclOverview = {
  totalPlants: 2840,
  capacityMWp: 96.4,
  todayMWh: 1824,
  activePlants: 2690,
  activePct: 94.7,
  offlinePlants: 150,
  avgPR: 78.9,
  avgCUF: 19.2,
  co2OffsetMT: 0.41,
  avgCufPct: 19.8,
  discomCo2OffsetMT: 0.18,
  sldcFeedStatus: 'LIVE' as 'LIVE' | 'OFFLINE',
  avgSpecificYield: 4.58,
};

// ─── PGVCL Generation — 15-day daily trend ───────────────────────────────────
export const pgvclGeneration = {
  daily: [
    { label: '14 Apr', value: 1604 },
    { label: '15 Apr', value: 1718 },
    { label: '16 Apr', value: 1653 },
    { label: '17 Apr', value: 1542 },
    { label: '18 Apr', value: 1810 },
    { label: '19 Apr', value: 1890 },
    { label: '20 Apr', value: 1752 },
    { label: '21 Apr', value: 1688 },
    { label: '22 Apr', value: 1830 },
    { label: '23 Apr', value: 1760 },
    { label: '24 Apr', value: 1695 },
    { label: '25 Apr', value: 1920 },
    { label: '26 Apr', value: 1875 },
    { label: '27 Apr', value: 1840 },
    { label: '28 Apr', value: 1824, highlighted: true },
  ] as GenerationDataPoint[],
  circleWise: [
    { label: 'Ahmedabad', value: 684 },
    { label: 'Gandhinagar', value: 428 },
    { label: 'Mehsana', value: 312 },
    { label: 'Ankleshwar', value: 248 },
    { label: 'Rajkot', value: 152 },
  ] as GenerationDataPoint[],
  topPlants: [
    { id: 'GJ-0182', consumer: 'Infosys Ltd', capacityKWp: 500, todayMWh: 2.84, prPercent: 83.2 },
    { id: 'GJ-0344', consumer: 'Adani Group', capacityKWp: 450, todayMWh: 2.61, prPercent: 82.4 },
    { id: 'GJ-1022', consumer: 'TCS Gandhinagar', capacityKWp: 400, todayMWh: 2.38, prPercent: 81.9 },
    { id: 'GJ-0781', consumer: 'Sun Pharma', capacityKWp: 380, todayMWh: 2.20, prPercent: 81.4 },
    { id: 'GJ-0490', consumer: 'GNFC Bharuch', capacityKWp: 350, todayMWh: 2.08, prPercent: 80.8 },
  ],
  bottomPlants: [
    { id: 'GJ-1842', consumer: 'Vinod Mehta', capacityKWp: 6, todayMWh: 0.021, prPercent: 46.2 },
    { id: 'GJ-2201', consumer: 'Ashok Bhatt', capacityKWp: 5, todayMWh: 0.018, prPercent: 49.1 },
    { id: 'GJ-0934', consumer: 'Meena Trivedi', capacityKWp: 8, todayMWh: 0.032, prPercent: 51.4 },
    { id: 'GJ-1543', consumer: 'Ramesh Amin', capacityKWp: 6, todayMWh: 0.028, prPercent: 54.8 },
    { id: 'GJ-0718', consumer: 'Kavita Shah', capacityKWp: 10, todayMWh: 0.052, prPercent: 56.3 },
  ],
  avgSpecificYield: 4.58,
};

// ─── Zebron Solar (Vendor) Generation data ────────────────────────────────────
export const zebronGeneration = {
  daily: [
    { label: '14 Apr', value: 2812 },
    { label: '15 Apr', value: 2940 },
    { label: '16 Apr', value: 2784 },
    { label: '17 Apr', value: 2645 },
    { label: '18 Apr', value: 3018 },
    { label: '19 Apr', value: 3142 },
    { label: '20 Apr', value: 2960 },
    { label: '21 Apr', value: 2876 },
    { label: '22 Apr', value: 3080 },
    { label: '23 Apr', value: 2982 },
    { label: '24 Apr', value: 2845 },
    { label: '25 Apr', value: 3210 },
    { label: '26 Apr', value: 3180 },
    { label: '27 Apr', value: 3124 },
    { label: '28 Apr', value: 3096, highlighted: true },
  ] as GenerationDataPoint[],
  stateWise: [
    { label: 'Gujarat', value: 1480 },
    { label: 'Rajasthan', value: 682 },
    { label: 'Maharashtra', value: 524 },
    { label: 'Karnataka', value: 248 },
    { label: 'Tamil Nadu', value: 162 },
  ] as GenerationDataPoint[],
  topPlants: [
    { id: 'GJ-0182', consumer: 'Infosys Ltd', capacityKWp: 500, todayKWh: 2840, prPercent: 83.2 },
    { id: 'RJ-0441', consumer: 'Rajasthan Petro', capacityKWp: 480, todayKWh: 2720, prPercent: 82.8 },
    { id: 'MH-1102', consumer: 'Mahindra Nashik', capacityKWp: 420, todayKWh: 2450, prPercent: 82.1 },
    { id: 'GJ-0344', consumer: 'Adani Group', capacityKWp: 450, todayKWh: 2610, prPercent: 81.9 },
    { id: 'KA-0288', consumer: 'Wipro Bengaluru', capacityKWp: 400, todayKWh: 2240, prPercent: 81.4 },
  ],
  bottomPlants: [
    { id: 'GJ-1842', consumer: 'Vinod Mehta', capacityKWp: 6, todayKWh: 21, prPercent: 46.2 },
    { id: 'MH-0812', consumer: 'Datta Jadhav', capacityKWp: 5, todayKWh: 18, prPercent: 48.9 },
    { id: 'GJ-2201', consumer: 'Ashok Bhatt', capacityKWp: 5, todayKWh: 18, prPercent: 49.1 },
    { id: 'RJ-1204', consumer: 'Hanuman Farms', capacityKWp: 10, todayKWh: 44, prPercent: 51.8 },
    { id: 'GJ-0934', consumer: 'Meena Trivedi', capacityKWp: 8, todayKWh: 32, prPercent: 51.4 },
  ],
  peakPowerMW: 248,
  avgSpecificYield: 3.42,
};

// ─── State Generation — Top 5 plants & PR trend ───────────────────────────────
export const stateTopPlants = [
  { id: 'GJ-1024', district: 'Ahmedabad', kwhToday: 48.2, prPct: 88.4 },
  { id: 'GJ-0482', district: 'Ahmedabad', kwhToday: 45.5, prPct: 87.1 },
  { id: 'GJ-0731', district: 'Surat',     kwhToday: 44.8, prPct: 86.3 },
  { id: 'GJ-1204', district: 'Rajkot',    kwhToday: 43.9, prPct: 85.9 },
  { id: 'GJ-0890', district: 'Vadodara',  kwhToday: 42.1, prPct: 85.2 },
];

// ─── National generation — monthly series ─────────────────────────────────────
export const nationalMonthlyByState: GenerationDataPoint[] = [
  { label: 'Rajasthan',    value: 7.24 },
  { label: 'Gujarat',      value: 5.81 },
  { label: 'Karnataka',    value: 4.12 },
  { label: 'Andhra Pradesh', value: 3.89 },
  { label: 'Tamil Nadu',   value: 3.42 },
  { label: 'Maharashtra',  value: 2.94 },
  { label: 'Others',       value: 8.58 },
];
